import http from './httpService';

const apiEndPoint = '/users';

function userUrl(id) {
  return `${apiEndPoint}/${id}`;
}

function userRoleUrl(id) {
  return `/users/is-admin/${id}`;
}

export function getUsers() {
  return http.get(`${apiEndPoint}`);
}

export function getAllAdmins() {
  return http.get(`${apiEndPoint}/getAllAdmins`);
}

export function getUser(userId) {
  return http.get(userUrl(userId));
}

export function saveUser(user) {
  if (user._id) {
    const body = { ...user };
    delete body._id;
    return http.put(userUrl(user._id), body);
  }

  return http.post(apiEndPoint, user);
}

export function userRole(user) {
  if (user._id) {
    const body = { ...user };
    delete body._id;
    return http.put(userRoleUrl(user._id), body);
  }
}

export function deleteUser(userId) {
  return http.delete(userUrl(userId));
}

export function getDailyUserSignup() {
  return http.get('/users/data');
}
